import React, { useState } from "react";
import { Button, Input, Modal, Popconfirm, Progress } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import TicketCard from "./TicketCard";
import { normalizeId } from "../constants";

export default function KanbanColumn({
  list,
  tickets,
  onAddTicket,
  onTicketClick,
  onDropTicket,
  canManage,
  creatingTicket,
  deletingList,
  onDeleteList,
}) {
  const [dragOver, setDragOver] = useState(false);
  const [adding, setAdding] = useState(false);
  const [newTitle, setNewTitle] = useState("");

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => setDragOver(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const ticketId = e.dataTransfer.getData("ticketId");
    if (ticketId) onDropTicket(ticketId, list._id);
  };

  const submitNew = () => {
    if (!newTitle.trim() || creatingTicket) return;
    onAddTicket(normalizeId(list._id), newTitle.trim());
    setNewTitle("");
    setAdding(false);
  };

  return (
    <div className={"kanban-column" + (creatingTicket ? " kanban-column-creating" : "")}>
      <div className="kanban-column-header">
        <span>
          <span
            style={{
              display: "inline-block",
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: list.color || "#94a3b8",
              marginRight: 8,
            }}
          />
          {list.name}
          <span style={{ color: "#94a3b8", fontWeight: 400, marginLeft: 8 }}>{tickets.length}</span>
        </span>
        {canManage && !list.is_default && (
          <Popconfirm title="Delete this list?" onConfirm={() => onDeleteList(list._id)}>
            <Button type="text" size="small" danger icon={<DeleteOutlined />} loading={deletingList} />
          </Popconfirm>
        )}
      </div>

      {creatingTicket && (
        <div className="kanban-column-progress">
          <Progress percent={100} showInfo={false} status="active" size="small" strokeColor="#6366f1" />
        </div>
      )}

      <div
        className={"kanban-column-body" + (dragOver ? " drag-over" : "")}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        {tickets.map((ticket) => (
          <TicketCard
            key={ticket._id}
            ticket={ticket}
            draggable={canManage}
            onClick={() => onTicketClick(ticket)}
            onDragStart={(e) => {
              e.dataTransfer.setData("ticketId", ticket._id);
              e.dataTransfer.effectAllowed = "move";
            }}
          />
        ))}

        {canManage && (
          adding ? (
            <div style={{ marginTop: 4 }}>
              <Input
                autoFocus
                size="small"
                placeholder="Ticket title…"
                value={newTitle}
                disabled={creatingTicket}
                onChange={(e) => setNewTitle(e.target.value)}
                onPressEnter={submitNew}
                onBlur={() => {
                  if (!newTitle.trim()) setAdding(false);
                }}
              />
              <Button
                type="primary"
                size="small"
                block
                style={{ marginTop: 6 }}
                onMouseDown={(e) => e.preventDefault()}
                onClick={submitNew}
                loading={creatingTicket}
                disabled={creatingTicket}
              >
                {creatingTicket ? "Adding…" : "Add"}
              </Button>
            </div>
          ) : (
            <Button
              type="dashed"
              block
              size="small"
              icon={<PlusOutlined />}
              onClick={() => setAdding(true)}
              style={{ marginTop: 4 }}
            >
              Add ticket
            </Button>
          )
        )}
      </div>
    </div>
  );
}
